import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getCurrentUser } from '../data/auth';
import { acquireGraphTokenSilently, connectGraph } from '../data/graphAuth';
import { describeApiError } from '../data/http';

/** Whether the signed-in user already has a Microsoft 365 token for Graph, and a way to get one. */
export function useGraphConnection() {
  const { t } = useTranslation();
  const [state, setState] = useState<'checking' | 'ready' | 'needed'>('checking');
  const [user, setUser] = useState<string | undefined>();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    getCurrentUser()
      .then(async (current) => {
        if (!cancelled) setUser(current?.userDetails);
        return acquireGraphTokenSilently(current?.userDetails);
      })
      .then((token) => {
        if (!cancelled) setState(token ? 'ready' : 'needed');
      })
      .catch(() => {
        if (!cancelled) setState('needed');
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const connect = () => {
    setError(null);
    connectGraph(user)
      .then(() => setState('ready'))
      .catch((failure: unknown) => setError(describeApiError(failure, t('sharePoint.picker.connectFailed'))));
  };

  return { state, user, error, connect };
}
